export const financeQuestions = {
  conversation1: {
    id: 1,
    title: "Expense Report Submission",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/finance/finance1.mp3",
        script: `<mark>W</mark>: Hi, I need to submit my <mark>expense report</mark> for last week's business trip. Could you tell me what I need to include?
<span class="translation">(안녕하세요, 지난주 출장에 대한 경비 보고서를 제출해야 하는데요. 무엇을 포함해야 하는지 알려주시겠어요?)</span>

<mark>M</mark>: Sure. You should attach all your <mark>receipts</mark> and fill out the <mark>reimbursement form</mark>.
<span class="translation">(네. 모든 영수증을 첨부하고 환급 신청서를 작성하셔야 합니다.)</span>

<mark>W</mark>: I see. What about <mark>transportation costs</mark>?
<span class="translation">(알겠습니다. 교통비는 어떻게 하나요?)</span>

<mark>M</mark>: You can include taxi and train fares, but make sure to provide the receipts.
<span class="translation">(택시비와 기차요금을 포함할 수 있지만, 반드시 영수증을 제출하셔야 합니다.)</span>

<mark>W</mark>: Got it. I'll submit everything by this afternoon.
<span class="translation">(알겠습니다. 오후까지 모두 제출하도록 하겠습니다.)</span>

<mark>M</mark>: Great. The reimbursement should be processed within <mark>five business days</mark>.
<span class="translation">(좋습니다. 환급은 영업일 기준 5일 이내에 처리될 것입니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is <mark>the woman</mark> trying to do?",
        options: {
          A: "Book a <mark>business</mark> <mark>trip</mark>",
          B: "Submit an <mark>expense</mark> <mark>report</mark>",
          C: "Request a <mark>salary</mark> <mark>increase</mark>",
          D: "Ask about travel <mark>insurance</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Submit an expense report

대본 키워드: "I need to submit my expense report for last week's business trip"
보기 키워드: "Submit an expense report"

❌ 오답 트랩:
(A) Book a business trip 
→ 출장 예약이 아닌 경비 보고서 제출 논의

(C) Request a salary increase 
→ 급여 인상이 아닌 경비 보고서 제출 논의

(D) Ask about travel insurance 
→ 여행 보험이 아닌 경비 보고서 제출 논의`,
      },
      {
        id: 2,
        question: "What does <mark>the woman</mark> ask about?",
        options: {
          A: "The <mark>deadline</mark> for submitting reports",
          B: "How to include <mark>transportation</mark> <mark>costs</mark>",
          C: "Where to find the <mark>reimbursement</mark> <mark>form</mark>",
          D: "The company's <mark>travel</mark> <mark>policy</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) How to include transportation costs

대본 키워드: "What about transportation costs?"
보기 키워드: "How to include transportation costs"

❌ 오답 트랩:
(A) The deadline for submitting reports 
→ 제출 기한에 대해 묻지 않음

(C) Where to find the reimbursement form 
→ 환급 신청서 위치에 대해 묻지 않음

(D) The company's travel policy 
→ 회사 출장 정책에 대해 묻지 않음`,
      },
      {
        id: 3,
        question: "When will the reimbursement be processed?",
        options: {
          A: "<mark>Immediately</mark>",
          B: "In <mark>three</mark> days",
          C: "In <mark>five</mark> business days",
          D: "In <mark>one</mark> <mark>week</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) In five business days

대본 키워드: "The reimbursement should be processed within five business days"
보기 키워드: "In five business days"

❌ 오답 트랩:
(A) Immediately 
→ 즉시가 아닌 5영업일 소요

(B) In three days 
→ 3일이 아닌 5영업일 소요

(D) In one week 
→ 1주일이 아닌 5영업일 소요`,
      },
    ],
  },
  conversation2: {
    id: 2,
    title: "Lost Credit Card Report",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/finance/finance2.mp3",
        script: `<mark>W</mark>: Hello, I need to report a <mark>lost credit card</mark>. What should I do?
<span class="translation">(안녕하세요, 신용카드를 분실해서 신고해야 하는데요. 어떻게 해야 하나요?)</span>

<mark>M</mark>: I can help with that. Can you provide your <mark>account number</mark> and the <mark>last four digits</mark> of the lost card?
<span class="translation">(도와드리겠습니다. 계좌번호와 분실한 카드의 마지막 네 자리를 알려주시겠어요?)</span>

<mark>W</mark>: Sure. My account number is 567890, and the <mark>last four digits</mark> are 3421.
<span class="translation">(네. 제 계좌번호는 567890이고, 마지막 네 자리는 3421입니다.)</span>

<mark>M</mark>: Thank you. I've blocked the card to prevent unauthorized use. Would you like us to issue a replacement?
<span class="translation">(감사합니다. 무단 사용을 방지하기 위해 카드를 차단했습니다. 교체 카드를 발급해드릴까요?)</span>

<mark>W</mark>: Yes, please. How long will it take to arrive?
<span class="translation">(네, 부탁드립니다. 도착하는 데 얼마나 걸리나요?)</span>

<mark>M</mark>: It should be delivered within <mark>five business days</mark>.
<span class="translation">(영업일 기준 5일 이내에 배송될 예정입니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is <mark>the woman</mark> calling about?",
        options: {
          A: "A <mark>loan</mark> application",
          B: "A <mark>billing</mark> issue",
          C: "A lost <mark>credit card</mark>",
          D: "A <mark>credit limit</mark> increase",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) A lost credit card

대본 키워드: "I need to report a lost credit card"
보기 키워드: "A lost credit card"

❌ 오답 트랩:
(A) A loan application 
→ 대출 신청이 아닌 분실 카드 신고

(B) A billing issue 
→ 청구 문제가 아닌 분실 카드 신고

(D) A credit limit increase 
→ 한도 증액이 아닌 분실 카드 신고`,
      },
      {
        id: 2,
        question: "What information does <mark>the woman</mark> provide?",
        options: {
          A: "Her card <mark>expiration</mark> <mark>date</mark>",
          B: "The <mark>last four digits</mark> of her card",
          C: "The <mark>name of the bank</mark> branch",
          D: "Her <mark>home</mark> <mark>address</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) The last four digits of her card

대본 키워드: "the last four digits are 3421"
보기 키워드: "The last four digits of her card"

❌ 오답 트랩:
(A) Her card expiration date 
→ 카드 만료일 제공하지 않음

(C) The name of the bank branch 
→ 은행 지점명 제공하지 않음

(D) Her home address 
→ 집 주소 제공하지 않음`,
      },
      {
        id: 3,
        question: "How long will it take to receive the new card?",
        options: {
          A: "<mark>Two</mark> business days",
          B: "<mark>Three</mark> business days",
          C: "<mark>Five</mark> business days",
          D: "<mark>One week</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Five business days

대본 키워드: "It should be delivered within five business days"
보기 키워드: "Five business days"

❌ 오답 트랩:
(A) Two business days 
→ 2영업일이 아닌 5영업일 소요

(B) Three business days 
→ 3영업일이 아닌 5영업일 소요

(D) One week 
→ 1주일이 아닌 5영업일 소요`,
      },
    ],
  },
  conversation3: {
    id: 3,
    title: "Incorrect Billing Charge",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/finance/finance3.mp3",
        script: `<mark>M</mark>: Hello, I'm calling about a <mark>billing issue</mark>. My credit card statement shows an <mark>incorrect charge</mark>.
<span class="translation">(안녕하세요, 청구 문제 때문에 전화드렸습니다. 제 신용카드 명세서에 잘못된 청구가 있네요.)</span>

<mark>W</mark>: I see. Could you provide the <mark>transaction details</mark>?
<span class="translation">(알겠습니다. 거래 내역을 알려주시겠어요?)</span>

<mark>M</mark>: Sure. It's a $120 charge from a restaurant, but I only spent $80.
<span class="translation">(네. 레스토랑에서 120달러가 청구됐는데, 실제로는 80달러만 사용했습니다.)</span>

<mark>W</mark>: Thank you for the details. I will review the transaction and process a <mark>refund</mark> for the difference.
<span class="translation">(상세 내용 감사합니다. 거래를 검토하고 차액을 환불 처리하도록 하겠습니다.)</span>

<mark>M</mark>: That would be great. How long will it take?
<span class="translation">(좋습니다. 얼마나 걸리나요?)</span>

<mark>W</mark>: The adjustment should appear on your <mark>next statement</mark>.
<span class="translation">(다음 명세서에 조정된 내용이 반영될 것입니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is <mark>the man</mark> calling about?",
        options: {
          A: "A <mark>billing</mark> issue",
          B: "A <mark>lost</mark> <mark>credit</mark> <mark>card</mark>",
          C: "A <mark>loan</mark> payment",
          D: "A <mark>refund</mark> request",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) A billing issue

대본 키워드: "I'm calling about a billing issue"
보기 키워드: "A billing issue"

❌ 오답 트랩:
(B) A lost credit card 
→ 분실 카드가 아닌 청구 문제

(C) A loan payment 
→ 대출 납부가 아닌 청구 문제

(D) A refund request 
→ 단순 환불 요청이 아닌 잘못된 청구 문제`,
      },
      {
        id: 2,
        question: "What does <mark>the man</mark> say about the charge?",
        options: {
          A: "He <mark>did not make</mark> the <mark>payment</mark>",
          B: "The <mark>amount</mark> is <mark>incorrect</mark>",
          C: "The restaurant charged him <mark>twice</mark>",
          D: "His payment was <mark>declined</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) The amount is incorrect

대본 키워드: "It's a $120 charge from a restaurant, but I only spent $80"
보기 키워드: "The amount is incorrect"

❌ 오답 트랩:
(A) He did not make the payment 
→ 결제하지 않은 것이 아닌 금액이 잘못됨

(C) The restaurant charged him twice 
→ 이중 청구가 아닌 금액이 잘못됨

(D) His payment was declined 
→ 결제 거절이 아닌 금액이 잘못됨`,
      },
      {
        id: 3,
        question: "When will the refund be processed?",
        options: {
          A: "Within a <mark>day</mark>",
          B: "On the <mark>next</mark> <mark>statement</mark>",
          C: "In <mark>two</mark> <mark>weeks</mark>",
          D: "<mark>Immediately</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) On the next statement

대본 키워드: "The adjustment should appear on your next statement"
보기 키워드: "On the next statement"

❌ 오답 트랩:
(A) Within a day 
→ 하루 이내가 아닌 다음 명세서에 반영

(C) In two weeks 
→ 2주 후가 아닌 다음 명세서에 반영

(D) Immediately 
→ 즉시가 아닌 다음 명세서에 반영`,
      },
    ],
  },
  conversation4: {
    id: 4,
    title: "Department Budget Review",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/finance/finance4.mp3",
        script: `<mark>M</mark>: Hi, Lisa. I wanted to go over our <mark>department's budget</mark> before we finalize the quarterly report.
<span class="translation">(안녕하세요, Lisa. 분기 보고서를 마무리하기 전에 우리 부서 예산을 검토하고 싶습니다.)</span>

<mark>W</mark>: Sure, Tom. I reviewed the figures, and we've <mark>exceeded</mark> our projected spending by about ten percent.
<span class="translation">(네, Tom. 수치를 검토해봤는데, 예상 지출을 약 10% 초과했어요.)</span>

<mark>M</mark>: That's more than I expected. What caused the increase?
<span class="translation">(예상보다 많네요. 무엇 때문에 증가했나요?)</span>

<mark>W</mark>: Mostly <mark>travel expenses</mark>. We had more client meetings than planned.
<span class="translation">(주로 출장 비용이에요. 계획했던 것보다 고객 미팅이 더 많았거든요.)</span>

<mark>M</mark>: I see. We should reduce non-essential expenses next quarter. Any recommendations?
<span class="translation">(그렇군요. 다음 분기에는 불필요한 지출을 줄여야겠네요. 제안할 것이 있나요?)</span>

<mark>W</mark>: We could limit business trips and shift some meetings to <mark>virtual calls</mark>.
<span class="translation">(출장을 제한하고 일부 미팅을 화상 통화로 전환할 수 있을 것 같아요.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What are <mark>the speakers</mark> discussing?",
        options: {
          A: "A <mark>new</mark> project <mark>proposal</mark>",
          B: "<mark>Hiring</mark> additional <mark>employees</mark>",
          C: "The department's <mark>budget</mark> <mark>review</mark>",
          D: "A change in company <mark>policy</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) The department's budget review

대본 키워드: "I wanted to go over our department's budget before we finalize the quarterly report"
보기 키워드: "The department's budget review"

❌ 오답 트랩:
(A) A new project proposal 
→ 새 프로젝트가 아닌 예산 검토 논의

(B) Hiring additional employees 
→ 직원 채용이 아닌 예산 검토 논의

(D) A change in company policy 
→ 회사 정책 변경이 아닌 예산 검토 논의`,
      },
      {
        id: 2,
        question: "What caused the budget overage?",
        options: {
          A: "Increased office <mark>supply</mark> <mark>costs</mark>",
          B: "Higher employee <mark>salaries</mark>",
          C: "<mark>Unexpected</mark> <mark>equipment</mark> purchases",
          D: "More <mark>business</mark> <mark>travel</mark> than expected",
        },
        correctAnswer: "D",
        explanation: `✅ 정답: (D) More business travel than expected

대본 키워드: "Mostly travel expenses. We had more client meetings than planned"
보기 키워드: "More business travel than expected"

❌ 오답 트랩:
(A) Increased office supply costs 
→ 사무용품 비용이 아닌 출장 비용 증가

(B) Higher employee salaries 
→ 직원 급여가 아닌 출장 비용 증가

(C) Unexpected equipment purchases 
→ 장비 구매가 아닌 출장 비용 증가`,
      },
      {
        id: 3,
        question: "What does <mark>the woman</mark> suggest?",
        options: {
          A: "Increasing the budget for <mark>next quarter</mark>",
          B: "<mark>Delaying</mark> the financial <mark>report</mark> submission",
          C: "Reducing <mark>department</mark> <mark>headcounts</mark>",
          D: "Holding <mark>virtual</mark> <mark>meetings</mark> instead of traveling",
        },
        correctAnswer: "D",
        explanation: `✅ 정답: (D) Holding virtual meetings instead of traveling

대본 키워드: "We could limit business trips and shift some meetings to virtual calls"
보기 키워드: "Holding virtual meetings instead of traveling"

❌ 오답 트랩:
(A) Increasing the budget for next quarter 
→ 예산 증액이 아닌 가상 회의 제안

(B) Delaying the financial report submission 
→ 보고서 제출 연기가 아닌 가상 회의 제안

(C) Reducing department headcounts 
→ 인원 감축이 아닌 가상 회의 제안`,
      },
    ],
  },
  conversation5: {
    id: 5,
    title: "Missing Expense Receipts",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/finance/finance5.mp3",
        script: `<mark>M</mark>: Hi, Emily. I just submitted my <mark>expense report</mark> for the recent business trip. I wanted to check if everything is in order.
<span class="translation">(안녕하세요, Emily. 방금 최근 출장에 대한 경비 보고서를 제출했는데요. 모든 것이 제대로 되어있는지 확인하고 싶습니다.)</span>

<mark>W</mark>: Thanks, Mark. I've reviewed it, but a few <mark>receipts</mark> seem to be <mark>missing</mark>.
<span class="translation">(감사합니다, Mark. 검토해봤는데 몇 개의 영수증이 누락된 것 같네요.)</span>

<mark>M</mark>: Oh, really? Which ones?
<span class="translation">(아, 정말요? 어떤 것들인가요?)</span>

<mark>W</mark>: The hotel stay and two taxi rides are not accounted for. Do you have those receipts?
<span class="translation">(호텔 숙박비와 택시비 두 건이 누락되어 있네요. 해당 영수증들 있으신가요?)</span>

<mark>M</mark>: Yes, I have them right here. I must have forgotten to attach them.
<span class="translation">(네, 여기 있습니다. 첨부하는 것을 잊었나 봅니다.)</span>

<mark>W</mark>: No problem. Please <mark>send them over</mark>, and I'll process your reimbursement today.
<span class="translation">(괜찮습니다. 보내주시면 오늘 환급 처리해드리도록 하겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is <mark>the man</mark> doing?",
        options: {
          A: "Preparing for a <mark>business</mark> <mark>trip</mark>",
          B: "Reviewing a company <mark>invoice</mark>",
          C: "Submitting an <mark>expense</mark> <mark>report</mark>",
          D: "Requesting a travel <mark>refund</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Submitting an expense report

대본 키워드: "I just submitted my expense report for the recent business trip"
보기 키워드: "Submitting an expense report"

❌ 오답 트랩:
(A) Preparing for a business trip 
→ 출장 준비가 아닌 경비 보고서 제출

(B) Reviewing a company invoice 
→ 회사 청구서 검토가 아닌 경비 보고서 제출

(D) Requesting a travel refund 
→ 여행 환불 요청이 아닌 경비 보고서 제출`,
      },
      {
        id: 2,
        question: "What issue does <mark>the woman</mark> mention?",
        options: {
          A: "A <mark>payment</mark> has been <mark>delayed</mark>",
          B: "The company's <mark>budget</mark> has been <mark>exceeded</mark>",
          C: "Some <mark>receipts</mark> are <mark>missing</mark>",
          D: "The man used the <mark>wrong</mark> <mark>form</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Some receipts are missing

대본 키워드: "a few receipts seem to be missing"
보기 키워드: "Some receipts are missing"

❌ 오답 트랩:
(A) A payment has been delayed 
→ 지불 지연이 아닌 영수증 누락

(B) The company's budget has been exceeded 
→ 예산 초과가 아닌 영수증 누락

(D) The man used the wrong form 
→ 잘못된 양식이 아닌 영수증 누락`,
      },
      {
        id: 3,
        question: "What will <mark>the man</mark> most likely do next?",
        options: {
          A: "Send the missing <mark>receipts</mark>",
          B: "Call the <mark>travel</mark> <mark>agency</mark>",
          C: "<mark>Revise</mark> his entire <mark>report</mark>",
          D: "Speak to his <mark>manager</mark> about reimbursement",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Send the missing receipts

대본 키워드: "Please send them over, and I'll process your reimbursement today"
보기 키워드: "Send the missing receipts"

❌ 오답 트랩:
(B) Call the travel agency 
→ 여행사 연락이 아닌 누락된 영수증 전송

(C) Revise his entire report 
→ 전체 보고서 수정이 아닌 누락된 영수증 전송

(D) Speak to his manager about reimbursement 
→ 관리자 상담이 아닌 누락된 영수증 전송`,
      },
    ],
  },
  conversation6: {
    id: 6,
    title: "Car Insurance Claim",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/finance/finance6.mp3",
        script: `<mark>M</mark>: Hello, this is Jake Thompson. I was in a minor <mark>car accident</mark> earlier today, and <mark>I'd like to file an insurance claim</mark>.
<span class="translation">(안녕하세요, Jake Thompson입니다. 오늘 일찍 경미한 차 사고가 있어서 보험 청구를 하고 싶습니다.)</span>

<mark>W</mark>: I'm sorry to hear that, Mr. Thompson. Are you and the other <mark>driver</mark> okay?
<span class="translation">(안타깝네요, Thompson 님. 귀하와 상대방 운전자 모두 괜찮으신가요?)</span>

<mark>M</mark>: Yes, fortunately, no one was injured. But my front bumper is damaged.
<span class="translation">(네, 다행히 부상자는 없습니다. 하지만 앞 범퍼가 파손됐어요.)</span>

<mark>W</mark>: I see. You'll need to submit a <mark>claim form</mark> along with <mark>photos</mark> of the damage.
<span class="translation">(알겠습니다. 손상 사진과 함께 청구 양식을 제출하셔야 합니다.)</span>

<mark>M</mark>: Got it. Anything else?
<span class="translation">(알겠습니다. 다른 것은 없나요?)</span>

<mark>W</mark>: Yes, a copy of the <mark>police report</mark> is also required. You can upload everything through our website.
<span class="translation">(네, 경찰 보고서 사본도 필요합니다. 모든 서류는 저희 웹사이트를 통해 업로드하실 수 있습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the purpose of the call?",
        options: {
          A: "To renew an insurance <mark>policy</mark>",
          B: "To file an insurance <mark>claim</mark>",
          C: "To request <mark>roadside</mark> <mark>assistance</mark>",
          D: "To change <mark>coverage</mark> <mark>details</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) To report a car accident

대본 키워드: "I was in a minor car accident earlier today, and I'd like to file an insurance claim"
보기 키워드: "To report a car accident"

❌ 오답 트랩:
(A) To renew an insurance policy 
→ 보험 갱신이 아닌 사고 보고

(C) To request roadside assistance 
→ 긴급출동 요청이 아닌 사고 보고

(D) To change coverage details 
→ 보장 내용 변경이 아닌 사고 보고`,
      },
      {
        id: 2,
        question: "What does <mark>the woman</mark> ask about?",
        options: {
          A: "The cost of <mark>repairs</mark>",
          B: "The <mark>condition</mark> of the <mark>drivers</mark>",
          C: "The <mark>make</mark> and <mark>model</mark> of the car",
          D: "The location of the <mark>accident</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) The condition of the drivers

대본 키워드: "Are you and the other driver okay?"
보기 키워드: "The condition of the drivers"

❌ 오답 트랩:
(A) The cost of repairs 
→ 수리 비용이 아닌 운전자 상태 문의

(C) The make and model of the car 
→ 차량 정보가 아닌 운전자 상태 문의

(D) The location of the accident 
→ 사고 위치가 아닌 운전자 상태 문의`,
      },
      {
        id: 3,
        question: "What does <mark>the man</mark> need to submit?",
        options: {
          A: "A <mark>repair estimate</mark> from a mechanic",
          B: "A statement from a <mark>witness</mark>",
          C: "A signed agreement from <mark>both</mark> <mark>drivers</mark>",
          D: "A claim form, photos, and a <mark>police report</mark>",
        },
        correctAnswer: "D",
        explanation: `✅ 정답: (D) A claim form, photos, and a police report

대본 키워드: "You'll need to submit a claim form along with pictures of the damage" + "a copy of the police report is also required"
보기 키워드: "A claim form, photos, and a police report"

❌ 오답 트랩:
(A) A repair estimate from a mechanic 
→ 정비사 견적서는 요구되지 않음

(B) A statement from a witness 
→ 목격자 진술서는 요구되지 않음

(C) A signed agreement from both drivers 
→ 운전자 합의서는 요구되지 않음`,
      },
    ],
  },
  conversation7: {
    id: 7,
    title: "Health Insurance Enrollment",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/finance/finance7.mp3",
        script: `<mark>M</mark>: Hi, I'm a new employee, and I'd like to learn more about the company's <mark>health insurance</mark> plan.
<span class="translation">(안녕하세요, 신입 사원인데 회사의 건강보험 플랜에 대해 자세히 알고 싶습니다.)</span>

<mark>W</mark>: Of course. Our group health insurance covers medical, dental, and vision care.
<span class="translation">(네. 저희 단체 건강보험은 의료, 치과, 시력 진료를 보장합니다.)</span>

<mark>M</mark>: That sounds good. How much do I need to pay for it?
<span class="translation">(좋네요. 제가 얼마를 내야 하나요?)</span>

<mark>W</mark>: The company covers 80% of the premium, so your monthly contribution would be <mark>$50</mark>.
<span class="translation">(회사가 보험료의 80%를 부담하므로, 귀하의 월 부담금은 50달러입니다.)</span>

<mark>M</mark>: I see. What's the process to enroll?
<span class="translation">(알겠습니다. 가입 절차는 어떻게 되나요?)</span>

<mark>W</mark>: You just need to fill out an <mark>application form</mark>. I can send it to you by email.
<span class="translation">(가입 신청서만 작성하시면 됩니다. 이메일로 보내드리겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the conversation mainly about?",
        options: {
          A: "An employee's <mark>promotion</mark> <mark>benefits</mark>",
          B: "A company's <mark>health insurance</mark> plan",
          C: "A <mark>medical leave</mark> request",
          D: "A change in work <mark>schedule</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) A company's health insurance plan

대본 키워드: "I'd like to learn more about the company's health insurance plan"
보기 키워드: "A company's health insurance plan"

❌ 오답 트랩:
(A) An employee's promotion benefits 
→ 승진 혜택이 아닌 건강보험 안내

(C) A medical leave request 
→ 병가 신청이 아닌 건강보험 안내

(D) A change in work schedule 
→ 근무 일정 변경이 아닌 건강보험 안내`,
      },
      {
        id: 2,
        question:
          "How much does <mark>the man</mark> have to pay for the insurance?",
        options: {
          A: "<mark>$25</mark>",
          B: "<mark>$50</mark>",
          C: "<mark>$80</mark>",
          D: "<mark>$100</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) $50

대본 키워드: "your monthly contribution would be $50"
보기 키워드: "$50"

❌ 오답 트랩:
(A) $25 
→ 언급되지 않은 금액

(C) $80 
→ 회사 부담 비율과 혼동

(D) $100 
→ 언급되지 않은 금액`,
      },
      {
        id: 3,
        question: "What will <mark>the woman</mark> do next?",
        options: {
          A: "Provide a list of <mark>hospitals</mark>",
          B: "Send an <mark>application</mark> <mark>form</mark>",
          C: "Schedule a <mark>medical</mark> <mark>check-up</mark>",
          D: "Adjust the employee's <mark>work</mark> <mark>hours</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) Send an application form

대본 키워드: "I can send it to you by email"
보기 키워드: "Send an application form"

❌ 오답 트랩:
(A) Provide a list of hospitals 
→ 병원 목록 제공 언급 없음

(C) Schedule a medical check-up 
→ 건강검진 예약 언급 없음

(D) Adjust the employee's work hours 
→ 근무 시간 조정 언급 없음`,
      },
    ],
  },

  conversation8: {
    id: 8,
    title: "Invoice Payment Reminder",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/finance/finance8.mp3",
        script: `<mark>M</mark>: Hi, Susan. I just wanted to remind you that the <mark>invoice</mark> for the office supplies is due by the end of the week. Has the payment been processed yet?
<span class="translation">(안녕하세요, Susan. 사무용품 인보이스가 이번 주 말까지라서 알려드리려고 했어요. 결제는 처리되었나요?)</span>

<mark>W</mark>: Oh, thanks for the reminder. I haven't submitted the payment yet, but I'll take care of it this afternoon.
<span class="translation">(아, 알려주셔서 감사합니다. 아직 결제를 제출하지 않았는데, 오늘 오후에 처리하도록 하겠습니다.)</span>

<mark>M</mark>: Great. Also, regarding this month's <mark>payroll</mark>, salaries will be transferred on <mark>Friday</mark> as usual. If there are any changes, I'll let you know.
<span class="translation">(좋습니다. 그리고 이번 달 급여 관련해서, 급여는 평소처럼 금요일에 이체될 예정입니다. 변동사항이 있으면 알려드리겠습니다.)</span>

<mark>W</mark>: Sounds good. I'll make sure everything is ready for the invoice payment today.
<span class="translation">(알겠습니다. 오늘 인보이스 결제 준비를 확실히 하도록 하겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the main topic of the conversation?",
        options: {
          A: "A <mark>tax</mark> filing <mark>deadline</mark>",
          B: "An <mark>invoice</mark> payment <mark>reminder</mark>",
          C: "A department <mark>budget</mark> <mark>report</mark>",
          D: "A <mark>business</mark> <mark>trip</mark> expense claim",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) An invoice payment reminder

대본 키워드: "I just wanted to remind you that the invoice for the office supplies is due by the end of the week"
보기 키워드: "An invoice payment reminder"

❌ 오답 트랩:
(A) A tax filing deadline 
→ 세금 신고 마감이 아닌 인보이스 결제 알림

(C) A department budget report 
→ 부서 예산 보고가 아닌 인보이스 결제 알림

(D) A business trip expense claim 
→ 출장 비용 청구가 아닌 인보이스 결제 알림`,
      },
      {
        id: 2,
        question: "When will the salaries be transferred?",
        options: {
          A: "On <mark>Wednesday</mark>",
          B: "On <mark>Friday</mark>",
          C: "On <mark>Monday</mark>",
          D: "On <mark>Thursday</mark>",
        },
        correctAnswer: "B",
        explanation: `✅ 정답: (B) On Friday

대본 키워드: "salaries will be transferred on Friday as usual"
보기 키워드: "On Friday"

❌ 오답 트랩:
(A) On Wednesday 
→ 수요일이 아닌 금요일

(C) On Monday 
→ 월요일이 아닌 금요일

(D) On Thursday 
→ 목요일이 아닌 금요일`,
      },
      {
        id: 3,
        question: "What does <mark>the woman</mark> say she will do?",
        options: {
          A: "Process the <mark>invoice</mark> payment",
          B: "Submit an <mark>expense</mark> report",
          C: "Confirm the <mark>payroll</mark> details",
          D: "Contact the <mark>finance</mark> <mark>department</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Process the invoice payment

대본 키워드: "I'll take care of it this afternoon" + "I'll make sure everything is ready for the invoice payment today"
보기 키워드: "Process the invoice payment"

❌ 오답 트랩:
(B) Submit an expense report 
→ 비용 보고서 제출이 아닌 인보이스 결제 처리

(C) Confirm the payroll details 
→ 급여 명세 확인이 아닌 인보이스 결제 처리

(D) Contact the finance department 
→ 재무부서 연락이 아닌 인보이스 결제 처리`,
      },
    ],
  },

  conversation9: {
    id: 9,
    title: "Workplace Insurance Claim",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/finance/finance9.mp3",
        script: `<mark>M</mark>: Hi, Karen. I heard that one of our employees was <mark>injured</mark> at the warehouse yesterday. Have you processed the <mark>insurance claim</mark> for that yet?
<span class="translation">(안녕하세요, Karen. 어제 직원 한 명이 창고에서 다쳤다고 들었는데요. 보험 청구는 처리하셨나요?)</span>

<mark>W</mark>: Not yet. I just received the <mark>incident report</mark> this morning. <mark>I need to verify some details before submitting the claim</mark>.
<span class="translation">(아니요, 아직이요. 방금 사고 보고서를 받았어요. 청구서를 제출하기 전에 몇 가지 세부사항을 확인해야 합니다.)</span>

<mark>M</mark>: I see. Do you know how long it will take for the insurance company to process it? The employee is worried about covering the <mark>medical expenses</mark>.
<span class="translation">(그렇군요. 보험사가 처리하는 데 얼마나 걸릴까요? 직원이 의료비 때문에 걱정하고 있거든요.)</span>

<mark>W</mark>: It usually takes about a week. I'll make sure to submit everything by the <mark>end of today</mark> so the process isn't delayed.
<span class="translation">(보통 일주일 정도 걸립니다. 처리가 지연되지 않도록 오늘 안으로 모든 것을 제출하도록 하겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What are the speakers mainly discussing?",
        options: {
          A: "A workplace <mark>safety</mark> inspection",
          B: "A health <mark>insurance</mark> <mark>policy</mark> change",
          C: "An <mark>insurance claim</mark> for an injured employee",
          D: "A new employee <mark>benefits</mark> <mark>package</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) An insurance claim for an injured employee

대본 키워드: "Have you processed the insurance claim for that yet?"
보기 키워드: "An insurance claim for an injured employee"

❌ 오답 트랩:
(A) A workplace safety inspection 
→ 안전 점검이 아닌 보험 청구 논의

(B) A health insurance policy change 
→ 보험 정책 변경이 아닌 보험 청구 논의

(D) A new employee benefits package 
→ 새로운 복리후생이 아닌 보험 청구 논의`,
      },
      {
        id: 2,
        question:
          "What does the woman say she needs to do before submitting the claim?",
        options: {
          A: "Get approval from the <mark>manager</mark>",
          B: "Check the employee's <mark>medical</mark> <mark>records</mark>",
          C: "<mark>Verify</mark> some <mark>details</mark> in the report",
          D: "Contact the <mark>insurance</mark> <mark>company</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Verify some details in the report

대본 키워드: "I need to verify some details before submitting the claim"
보기 키워드: "Verify some details in the report"

❌ 오답 트랩:
(A) Get approval from the manager 
→ 관리자 승인 언급 없음

(B) Check the employee's medical records 
→ 의료 기록 확인 언급 없음

(D) Contact the insurance company 
→ 보험사 연락 언급 없음`,
      },
      {
        id: 3,
        question: "When will the woman submit the insurance claim?",
        options: {
          A: "<mark>Tomorrow</mark> <mark>morning</mark>",
          B: "By next <mark>Monday</mark>",
          C: "By the <mark>end of today</mark>",
          D: "After receiving more <mark>documents</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) By the end of today

대본 키워드: "I'll make sure to submit everything by the end of today"
보기 키워드: "By the end of today"

❌ 오답 트랩:
(A) Tomorrow morning 
→ 내일 아침이 아닌 오늘 안으로 제출

(B) By next Monday 
→ 다음 월요일이 아닌 오늘 안으로 제출

(D) After receiving more documents 
→ 추가 서류 수령 후가 아닌 오늘 안으로 제출`,
      },
    ],
  },

  conversation10: {
    id: 10,
    title: "Health Insurance Addition",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/finance/finance10.mp3",
        script: `<mark>M</mark>: Hi, Lisa. I have a question about our company's <mark>health insurance</mark>. I'd like to add my <mark>spouse</mark> to my plan. Is that possible?
<span class="translation">(안녕하세요, Lisa. 우리 회사 건강보험에 대해 질문이 있습니다. 제 배우자를 제 플랜에 추가하고 싶은데 가능할까요?)</span>

<mark>W</mark>: Yes, but you need to submit a request form. There's an <mark>open enrollment</mark> period every November, but exceptions can be made for major life events, like marriage.
<span class="translation">(네, 하지만 신청서를 제출하셔야 합니다. 매년 11월에 오픈 가입 기간이 있지만, 결혼과 같은 중요한 생활 변화가 있을 경우 예외가 가능합니다.)</span>

<mark>M</mark>: I see. My wife recently started a new job and her company doesn't provide health insurance. Would that qualify as a special case?
<span class="translation">(그렇군요. 제 아내가 최근에 새 직장을 시작했는데 그 회사에서 건강보험을 제공하지 않아요. 이런 경우도 특별한 경우로 인정되나요?)</span>

<mark>W</mark>: Yes, that situation should allow for an exception. Just send me the <mark>required documents</mark>, and I'll process the request for you.
<span class="translation">(네, 그런 상황이라면 예외로 인정될 수 있습니다. 필요한 서류만 보내주시면 신청을 처리해드리겠습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What does <mark>the man</mark> ask about?",
        options: {
          A: "Adding his <mark>spouse</mark> to his health insurance plan",
          B: "Changing his <mark>insurance</mark> <mark>provider</mark>",
          C: "Signing up for a new <mark>health plan</mark>",
          D: "<mark>Canceling</mark> his current insurance coverage",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Adding his spouse to his health insurance plan

대본 키워드: "I'd like to add my spouse to my plan"
보기 키워드: "Adding his spouse to his health insurance plan"

❌ 오답 트랩:
(B) Changing his insurance provider 
→ 보험사 변경이 아닌 배우자 추가 문의

(C) Signing up for a new health plan 
→ 새로운 보험 가입이 아닌 배우자 추가 문의

(D) Canceling his current insurance coverage 
→ 현재 보험 취소가 아닌 배우자 추가 문의`,
      },
      {
        id: 2,
        question:
          "What does <mark>the woman</mark> say about the open enrollment period?",
        options: {
          A: "It occurs <mark>twice</mark> a <mark>year</mark>",
          B: "It lasts for <mark>only</mark> a <mark>week</mark>",
          C: "It happens every <mark>November</mark>",
          D: "It is not required for <mark>dependent</mark> additions",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) It happens every November

대본 키워드: "There's an open enrollment period every November"
보기 키워드: "It happens every November"

❌ 오답 트랩:
(A) It occurs twice a year 
→ 연 2회 발생한다는 언급 없음

(B) It lasts for only a week 
→ 기간이 일주일이라는 언급 없음

(D) It is not required for dependent additions 
→ 예외가 가능하다고 했지만 필수가 아니라고 하지 않음`,
      },
      {
        id: 3,
        question: "What does <mark>the woman</mark> tell the man to do?",
        options: {
          A: "Wait for the <mark>next</mark> <mark>open</mark> <mark>enrollment</mark> period",
          B: "Speak with his <mark>spouse's</mark> <mark>employer</mark>",
          C: "Submit the required <mark>documents</mark>",
          D: "Contact the <mark>insurance</mark> <mark>company</mark> directly",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) Submit the required documents

대본 키워드: "Just send me the required documents, and I'll process the request for you"
보기 키워드: "Submit the required documents"

❌ 오답 트랩:
(A) Wait for the next open enrollment period 
→ 다음 가입 기간까지 기다리라고 하지 않음

(B) Speak with his spouse's employer 
→ 배우자의 고용주와 상담하라고 하지 않음

(D) Contact the insurance company directly 
→ 보험사에 직접 연락하라고 하지 않음`,
      },
    ],
  },

  conversation11: {
    id: 11,
    title: "Invoice Payment Status",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/finance/finance11.mp3",
        script: `<mark>M</mark>: Hi, this is Alex from BrightTech. I'm calling to check on the status of an <mark>invoice</mark> we submitted two weeks ago.
<span class="translation">(안녕하세요, BrightTech의 Alex입니다. 2주 전에 제출한 송장의 상태를 확인하고자 전화드렸습니다.)</span>

<mark>W</mark>: Let me check… Yes, I see it here. The payment is scheduled to be processed on <mark>Friday</mark>.
<span class="translation">(확인해보겠습니다... 네, 여기 있네요. 금요일에 결제가 처리될 예정입니다.)</span>

<mark>M</mark>: That's good to hear. Could you confirm the amount?
<span class="translation">(다행이네요. 금액을 확인해 주시겠어요?)</span>

<mark>W</mark>: Sure. The total amount being processed is $7,800.
<span class="translation">(네. 처리될 총액은 7,800달러입니다.)</span>

<mark>M</mark>: Great. Will we receive a <mark>payment receipt</mark> once it's completed?
<span class="translation">(좋습니다. 완료되면 결제 영수증을 받을 수 있나요?)</span>

<mark>W</mark>: Yes, a confirmation email will be sent automatically.
<span class="translation">(네, 확인 이메일이 자동으로 발송될 것입니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What is the purpose of the call?",
        options: {
          A: "To update <mark>payment</mark> <mark>details</mark>",
          B: "To request a <mark>refund</mark>",
          C: "To check the status of an <mark>invoice</mark>",
          D: "To dispute a <mark>charge</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) To check the status of an invoice

대본 키워드: "I'm calling to check on the status of an invoice"
보기 키워드: "To check the status of an invoice"

❌ 오답 트랩:
(A) To update payment details 
→ 결제 정보 업데이트가 아닌 송장 상태 확인

(B) To request a refund 
→ 환불 요청이 아닌 송장 상태 확인

(D) To dispute a charge 
→ 청구 이의 제기가 아닌 송장 상태 확인`,
      },
      {
        id: 2,
        question: "When will the payment be made?",
        options: {
          A: "Tomorrow <mark>afternoon</mark>",
          B: "Next <mark>Monday</mark>",
          C: "On <mark>Friday</mark>",
          D: "It has <mark>already</mark> been <mark>processed</mark>",
        },
        correctAnswer: "C",
        explanation: `✅ 정답: (C) On Friday

대본 키워드: "The payment is scheduled to be processed on Friday"
보기 키워드: "On Friday"

❌ 오답 트랩:
(A) Tomorrow afternoon 
→ 내일 오후가 아닌 금요일

(B) Next Monday 
→ 다음 월요일이 아닌 금요일

(D) It has already been processed 
→ 이미 처리된 것이 아닌 금요일 예정`,
      },
      {
        id: 3,
        question: "What does <mark>the man</mark> ask about?",
        options: {
          A: "<mark>Receiving</mark> a payment <mark>receipt</mark>",
          B: "<mark>Changing</mark> the <mark>invoice</mark> details",
          C: "Extending the payment <mark>deadline</mark>",
          D: "Speaking with a <mark>finance</mark> <mark>manager</mark>",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Receiving a payment receipt

대본 키워드: "Will we receive a payment receipt once it's completed?"
보기 키워드: "Receiving a payment receipt"

❌ 오답 트랩:
(B) Changing the invoice details 
→ 송장 정보 변경이 아닌 영수증 수령 문의

(C) Extending the payment deadline 
→ 지불 기한 연장이 아닌 영수증 수령 문의

(D) Speaking with a finance manager 
→ 재무 담당자 면담이 아닌 영수증 수령 문의`,
      },
    ],
  },

  // ... existing code ...

  conversation12: {
    id: 12,
    title: "Vision Care Coverage",
    versions: {
      basic: {
        audioUrl: "/audios/Part3/finance/finance12.mp3",
        script: `<mark>M</mark>: Hi, I have a question about our company's <mark>health insurance</mark> policy. Does it cover <mark>vision care</mark>, like eye exams and prescription glasses?
<span class="translation">(안녕하세요, 우리 회사 건강보험 정책에 대해 질문이 있습니다. 시력 검사나 처방 안경과 같은 시력 관리도 보장되나요?)</span>

<mark>W</mark>: Actually, standard health insurance doesn't include vision care, but there is an <mark>optional vision plan</mark> that employees can enroll in.
<span class="translation">(사실, 기본 건강보험에는 시력 관리가 포함되지 않지만, 직원들이 선택적으로 가입할 수 있는 시력 보험이 있습니다.)</span>

<mark>M</mark>: Oh, I see. How much does the vision plan cost?
<span class="translation">(아, 그렇군요. 시력 보험은 얼마인가요?)</span>

<mark>W</mark>: It's $15 per month, and it covers annual eye exams as well as a portion of the cost for prescription glasses and contact lenses. If you're interested, you can sign up through the <mark>HR portal</mark>.
<span class="translation">(월 15달러이고, 연간 시력 검사와 처방 안경 및 콘택트렌즈 비용의 일부를 보장합니다. 관심이 있으시다면 HR 포털을 통해 가입하실 수 있습니다.)</span>`,
      },
    },
    questions: [
      {
        id: 1,
        question: "What does <mark>the man</mark> ask about?",
        options: {
          A: "<mark>Dental</mark> insurance coverage",
          B: "<mark>Life</mark> insurance policy options",
          C: "<mark>Emergency</mark> medical treatment",
          D: "<mark>Vision</mark> care benefits",
        },
        correctAnswer: "D",
        explanation: `✅ 정답: (D) Vision care benefits

대본 키워드: "Does it cover vision care, like eye exams and prescription glasses?"
보기 키워드: "Vision care benefits"

❌ 오답 트랩:
(A) Dental insurance coverage 
→ 치과 보험이 아닌 시력 관리 보험 문의

(B) Life insurance policy options 
→ 생명 보험이 아닌 시력 관리 보험 문의

(C) Emergency medical treatment 
→ 응급 치료가 아닌 시력 관리 보험 문의`,
      },
      {
        id: 2,
        question:
          "What does <mark>the woman</mark> say about vision care coverage?",
        options: {
          A: "It is included in the <mark>basic</mark> <mark>health</mark> <mark>plan</mark>",
          B: "It requires <mark>approval</mark> from a <mark>supervisor</mark>",
          C: "It is not available to <mark>part-time</mark> employees",
          D: "It is covered under a separate <mark>vision</mark> <mark>plan</mark>",
        },
        correctAnswer: "D",
        explanation: `✅ 정답: (D) It is covered under a separate vision plan

대본 키워드: "standard health insurance doesn't include vision care, but there is an optional vision plan"
보기 키워드: "It is covered under a separate vision plan"

❌ 오답 트랩:
(A) It is included in the basic health plan 
→ 기본 건강보험에 포함되지 않는다고 명시함

(B) It requires approval from a supervisor 
→ 상사 승인에 대한 언급 없음

(C) It is not available to part-time employees 
→ 파트타임 직원 관련 언급 없음`,
      },
      {
        id: 3,
        question: "What does <mark>the woman</mark> say the man can do?",
        options: {
          A: "Sign up through the <mark>HR</mark> <mark>portal</mark>",
          B: "Request a <mark>refund</mark> for medical expenses",
          C: "Schedule an <mark>eye exam</mark> with an in-network doctor",
          D: "Ask his <mark>manager</mark> for more details",
        },
        correctAnswer: "A",
        explanation: `✅ 정답: (A) Sign up through the HR portal

대본 키워드: "you can sign up through the HR portal"
보기 키워드: "Sign up through the HR portal"

❌ 오답 트랩:
(B) Request a refund for medical expenses 
→ 의료비 환급 요청 언급 없음

(C) Schedule an eye exam with an in-network doctor 
→ 검진 예약 언급 없음

(D) Ask his manager for more details 
→ 관리자 문의 언급 없음`,
      },
    ],
  },

  // ... existing code ...
};
